<template>
  <div class="modal animated is-active" v-if="service" v-show="active">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 1200px;">
      <header class="modal-card-head">
        <p class="modal-card-title">Booking-Service #{{ service.booking_id }}-{{ service.service_id }}</p>
      </header>
      <section class="modal-card-body">
        <div class="content">
          <div class="columns">
            <div class="column is-6">
              <div class="panel panel-info">
                <p class="panel-heading panel-heading-info">Hotel</p>
                <p class="panel-block"><i class="fa fa-bed"></i> {{ service.room.hotel.name }}</p>
                <p class="panel-block"><i class="fa fa-th-list"></i>
                  {{ service.room.description.substring(0,45) }}
                  <template v-if="service.room.description.length > 45">
                    <tooltip style="word-break: break-all;" :label="service.room.description" type="default" placement="right">
                      <a class="is-small">
                        <i class="fa fa-eye"></i>
                      </a>
                    </tooltip>
                  </template>
                </p>
                <p class="panel-block"><i class="fa fa-cutlery"></i> {{ service.room.board_description }}</p>
                <p class="panel-block"><i class="fa fa-calendar"></i> <b>{{ service.service_date | moment('YYYY-MM-DD') }}</b> to <b>{{ service.service_date | moment('add', service.room.number_nights + ' days', 'YYYY-MM-DD')}}</b></p>
                <p class="panel-block"><i class="fa fa-user"></i> {{ service.paxes.length }}</p>
                <p class="panel-block"><i class="fa fa-group"></i> Adults: <b>{{ service.room.number_adults }}</b> Children: <b>{{ service.room.number_children }}</b></p>
                <p class="panel-block"><i class="fa fa-moon-o"></i> {{ service.room.number_nights }}</p>
                <p class="panel-block"><i class="fa fa-usd"></i> Net: <b>{{ service.price + " " + service.currency }}</b> Provider: <b>{{ service.room.provider_price + " " + service.room.provider_currency }}</b></p>
                <p class="panel-block"><i class="fa fa-globe"></i> {{ service.room.hotel.city.name }}</p>
                <p class="panel-block"><i class="fa fa-map-marker"></i> {{ service.room.hotel.address }}</p>
                <p class="panel-block"><i class="fa fa-phone"></i> {{ service.room.hotel.phone }}</p>
              </div>
            </div>
            <div class="column is-6">
              <div class="panel panel-warning">
                <p class="panel-heading panel-heading-warning">Broker Info</p>
                <p class="panel-block"> {{ service.room.provider.name }}</p>
                <p class="panel-block"><i class="fa fa-hashtag"></i> {{ service.room.provider_booking_code }}</p>
                <p class="panel-block"><i class="fa fa-calendar"></i> {{ service.reservation_date }}</p>
                <p class="panel-heading panel-heading-warning">Customer Info</p>
                <!-- <p class="panel-block">Base: <b>{{ service.base.name }}</b></p> -->
                <p class="panel-block">Agency: <b>{{ service.agency.name }}</b></p>
              </div>
              <div class="panel">
                <p class="panel-heading">Cancellation</p>
                <p class="panel-block" v-for="cancellation in service.room.cancellation"><i class="fa fa-ban"></i> <b>From: </b> {{ cancellation.start_date | moment('YYYY-MM-DD hh:mm A') }} <b>To: </b>{{ cancellation.end_date | moment('YYYY-MM-DD hh:mm A') }} <b>Value: <span style="color: red;"> {{ parseFloat(cancellation.price).toFixed(2) }} {{cancellation.currency}}</span></b> - <b>{{ parseInt(cancellation.type) === 1 ? 'Provider' : 'Operator'}}</b></p>
              </div>
            </div>
          </div>
          <template v-if="service.observation && service.observation !== ''">
            <div class="columns">
              <div class="column is-12">
                <div class="panel panel-info">
                  <p class="panel-heading panel-heading-info">Observation</p>
                  <p class="panel-block">
                  <pre>{{ service.observation }}</pre>
                  </p>
                </div>
              </div>
            </div>
          </template>
          <!-- <div class="columns">
            <div class="column is-12">
              <div class="panel panel-success">
                <p class="panel-heading panel-heading-success">Paxs</p>
                <p class="panel-block" v-for="pax in service.paxes"><i class="fa fa-user"></i> {{ pax.title }} . {{ pax.name }} {{ pax.last_name }} - AGE: {{ pax.age }}</p>
              </div>
            </div>
          </div> -->
          <h1 style="margin-top: 10px; margin-bottom: 10px;">Cheaper Rooms</h1>
          <div class="columns">
            <div class="column is-3">
              <p class="control">
                <label class="label">Search</label>
                <input class="input" type="text" name="search" id="search" placeholder="Search" v-model="search" >
              </p>
            </div>
          </div>
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <th></th>
                <th>Room</th>
                <th>Board</th>
                <th>Supplier</th>
                <th>Cancellation</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="availability == null">
                <tr>
                  <td colspan="6" style="text-align: center;">
                    <i style="font-size: 90px;" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                  </td>
                </tr>
              </template>
              <template v-else>
                <template v-if="availability.length > 0">
                  <tr v-for="room in tableSearch" v-if="availability">
                    <td style="text-align: center;"><input type="radio" id="room" name="room" v-bind:value="room" v-model="selectedRoom"></td>
                    <td>{{ room.RoomDescription }}</td>
                    <td>{{ room.BoardDescription }}</td>
                    <td>{{ room.SupplierName }}</td>
                    <td>{{ room.hasOwnProperty('OperatorCancellationPolicies') ? parseDate(room.OperatorCancellationPolicies.CancellationPolicy.StartDate) : '' }}</td>
                    <td>{{ room.SellPriceTotal.Value }} {{ room.SellPriceTotal.Currency }}</td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="6" style="text-align: center;">
                      Rates are no longer available
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Close</a>
            <a class="button is-success" @click="next()" :class="{'is-disabled': selectedRoom === null}">Continue</a>
            <a class="button is-info" @click="exclude()">Remove</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../utils/message'
  import Change from '../bi/change'
  export default {
    props: {
      context: {
        type: Object
      },
      service_id: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        service: null,
        availability: null,
        selectedRoom: null,
        search: '',
        token: '',
        active: false
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/services/' + this.service_id).then((response) => {
          this.service = response.body
          document.body.appendChild(this.$el)
          this.active = true
          this.loadSearchAvailability()
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      loadSearchAvailability () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/bi/search_availability/' + this.service_id).then((response) => {
          this.availability = this.parseAvailability(response.body)
          this.token = response.body.Token
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      parseAvailability (availability) {
        if (availability.hasOwnProperty('error') && parseInt(availability.error) === 1 && availability.description.response.NumberOfResultsAfterFilter === 0) {
          let msg = '0 results after filter. NumberOfTotalResults":' + availability.description.response.NumberOfTotalResults
          let propsData = {
            title: 'Error',
            message: msg,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
          return availability.description.response
        }
        var avaiabilityArray = []
        if (availability.Hotels.hasOwnProperty('HotelResultEzlink')) {
          if (availability.Hotels.HotelResultEzlink.Rooms.RoomResultEzlink.hasOwnProperty('RoomId')) {
            if (parseFloat(this.service.room.provider_price) >= (parseFloat(availability.Hotels.HotelResultEzlink.Rooms.RoomResultEzlink.SellPriceTotal.Value) + parseFloat(0))) {
              avaiabilityArray.push(availability.Hotels.HotelResultEzlink.Rooms.RoomResultEzlink)
            }
          } else {
            for (var i = 0; i < availability.Hotels.HotelResultEzlink.Rooms.RoomResultEzlink.length; i++) {
              if (parseFloat(this.service.room.provider_price) >= (parseFloat(availability.Hotels.HotelResultEzlink.Rooms.RoomResultEzlink[i].SellPriceTotal.Value) + parseFloat(0))) {
                avaiabilityArray.push(availability.Hotels.HotelResultEzlink.Rooms.RoomResultEzlink[i])
              }
            }
          }
        }
        return avaiabilityArray
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      next () {
        let propsData = {
          context: this.context,
          service_id: parseInt(this.service_id),
          token: this.token,
          hotelid: parseInt(this.selectedRoom.HotelId),
          supplier: this.selectedRoom.SupplierName,
          room: this.selectedRoom.RoomId,
          callback: 'openChangeConfirm',
          parent: this
        }
        Change.openChangeConfirm(propsData)
        this.active = false
      },
      openChangeConfirm () {
        this.active = true
      },
      exclude () {
        this.context.$http.post(this.context.$store.state.config.apiURL + '/bi/save_remove', {'remove': this.service.id}).then((response) => {
          this.context.$parent.$parent.reload()
          this.$el.remove()
        }, (response) => {
        })
      },
      parseDate (content) {
        return this.$moment(content).format('YYYY-MM-DD')
      },
      find: function (list, value) {
        return list.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(value) > -1
          })
        })
      }
    },
    computed: {
      tableSearch () {
        return this.find(this.availability, this.search, 'name')
      },
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
      Tooltip
    }
  }
</script>
<style lang="scss" scoped>
.is-title {
  text-transform: capitalize;
}

.content p:not(:last-child) {
  margin-bottom: 0;
}

.panel {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
  color: #4a4a4a;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: flex;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
  background-color: rgb(167, 28, 32);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel-success {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(35, 209, 96), 0px 0px 0px 1px rgb(35, 209, 96);
  color: #23d160;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading-success {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: block;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(35, 209, 96), 0px 0px 0px 0px rgb(35, 209, 96);
  background-color: rgb(35, 209, 96);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel-info {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(50, 115, 220), 0px 0px 0px 1px rgb(50, 115, 220);
  color: #3273dc;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading-info {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: flex;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(50, 115, 220), 0px 0px 0px 0px rgb(50, 115, 220);
  background-color: rgb(50, 115, 220);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel-warning {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(255, 221, 87), 0px 0px 0px 1px rgb(255, 221, 87);
  color: #ffdd57;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading-warning {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: block;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(255, 221, 87), 0px 0px 0px 0px rgb(255, 221, 87);
  background-color: rgb(255, 221, 87);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

pre {
  background-color: #FFFFFF;
  white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
  white-space: -pre-wrap; /* Opera */
  white-space: -o-pre-wrap; /* Opera */
  white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
  word-wrap: break-word; /* IE 5.5+ */
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
  color: #4a4a4a;
  font-size: 1rem;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// Change.vue?290a0c6f